module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"generate-link":"Criar link","copy":"Copiar","copied":"Copiado!","link":"Link: {link}"},"en-US":{"generate-link":"Generate link","copy":"Copy","copied":"Copied!","link":"Link: {link}"}}')
  delete Component.options._Ctor
}
